import liff from '@line/liff';

function isLoopback(): boolean {
  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
}

export async function getIdentityToken(): Promise<string> {
  const params = new URLSearchParams(window.location.search);
  if (isLoopback() && params.get('mock') === '1') {
    const mockRole = params.get('mockUser');
    const mockUser = mockRole === 'admin'
      ? 'U_P1_ADMIN'
      : mockRole === 'editor' ? 'U_P1_EDITOR' : mockRole === 'claim' ? 'U_P1_CLAIM' : 'U_P1_VIEWER';
    return `phase1-mock:${mockUser}`;
  }

  const configResponse = await fetch('/api/config', { headers: { accept: 'application/json' } });
  if (!configResponse.ok) throw new Error('無法讀取 LIFF 設定。');
  const config = await configResponse.json() as { liffId: string | null };
  if (!config.liffId) throw new Error('LIFF 尚未完成設定。');
  await liff.init({ liffId: config.liffId });
  if (!liff.isLoggedIn()) {
    liff.login({ redirectUri: window.location.href });
    throw new Error('正在前往 LINE 登入…');
  }
  const token = liff.getIDToken();
  if (!token) throw new Error('LINE 沒有提供身分憑證，請重新開啟案件卡。');
  return token;
}
